var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home container page"},[_c('div',{staticClass:"rows"},_vm._l((_vm.data),function(cat){return _c('row',{key:cat.id,attrs:{"data":cat}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }